export default (str: string) => {
  return str.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue');
};
